// 创键微信草稿
import { useContext, useEffect } from "react"
import { CalendarContext } from "Components/Calendar/context"
import { Board, BoardModifyDialog } from "Types/board"
import { useInputChange } from "Hooks/basic"
import { useAddWeChatBoard, useUpdateWeChatBoardTime } from "Hooks/board"
import { useCreateStaticArticleType, useWeChatExternals } from "Components/Calendar/WeChatModal/hooks"
import request from "Methods/request"
import { InitialModal } from "Methods/modal"
import { AppContext } from "Views/Home/context"
import { checkUserPrivilege } from "Methods/privilege"

export function useCreateDraft() {
    const { external, handleChangeArticleType, handleChangeAuthor, resetExternal } = useWeChatExternals(null)
    const {
        boardModifyDialog, handleChangeBoardModifyDialog,
    } = useContext(CalendarContext)
    const { roleMap } = useContext(AppContext)
    const { isBusiness } = roleMap
    const dialogData = boardModifyDialog as BoardModifyDialog
    const { text, handleChange, clearText } = useInputChange("")
    const { text: projectId, handleChange: handleProjectIdChange, clearText: clearProjectId, setText: setProjectId } = useInputChange("")
    const { text: projectMoney, handleChange: handleProjectMoneyChange, clearText: clearProjectMoney, setText: setProjectMoney } = useInputChange("")
    const staticArticleType = useCreateStaticArticleType()
    const disabled = text === "" || external.articleTypeId === 0 || external.author.principalId === ""
    const { add } = useAddWeChatBoard()
    const callback = async () => {
        await add({
            description: text,
            author_id: external.author.authorId,
            article_type_id: external.articleTypeId,
            ad_times: [new Date().getTime()],
            seq_id: 100,
            is_draft: true,
            project_id: projectId || '',
            project_money: projectMoney || '',
        })
        resetExternal()
    }
    const cancelCallback = () => {
        handleChangeBoardModifyDialog(null)
        clearText()
        clearProjectId()
        clearProjectMoney()
        resetExternal()
    }
    return {
        callback, cancelCallback,
        dialogData, disabled, isBusiness,
        text, handleChange,
        projectId, handleProjectIdChange,
        projectMoney, handleProjectMoneyChange,
        handleChangeAuthor, handleChangeArticleType,
        staticArticleType,
    }
}
// 修改微信草稿
export function useUpdatedDraft() {
    const { boardModifyDialog, handleChangeBoardModifyDialog, handleSetEditMaterial } = useContext(CalendarContext)
    const dialogData = boardModifyDialog as BoardModifyDialog
    const board = dialogData.board as Board
    const { external, handleChangeAuthor, handleChangeArticleType, resetExternal } = useWeChatExternals(board)
    const { text, handleChange, clearText, setText } = useInputChange(board.description)
    const { text: projectId, handleChange: handleProjectIdChange, clearText: clearProjectId, setText: setProjectId } = useInputChange(board.project_id)
    const { text: projectMoney, handleChange: handleProjectMoneyChange, clearText: clearProjectMoney, setText: setProjectMoney } = useInputChange(board.project_money)
    const staticArticleType = useCreateStaticArticleType()
    const { handleChangeModal, privilegeMap, roleMap, user } = useContext(AppContext)
    const { update: materialUpdate = false } = checkUserPrivilege(privilegeMap, "material")
    const { isUser, isBusiness } = roleMap
    const isMine = board.creator_id === user.uid
    useEffect(() => {
        setText(board.description)
        setProjectId(board.project_id)
        setProjectMoney(board.project_money)
    }, [board, setText, setProjectId, setProjectMoney])
    const disabled = text === "" || external.articleTypeId === 0 || external.author.principalId === ""
    const { updateTime } = useUpdateWeChatBoardTime()
    const callback = async () => {
        await updateTime(board.id, {
            description: text,
            author_id: external.author.authorId,
            article_type_id: external.articleTypeId,
            is_draft: true,
            ad_time: new Date(new Date().setHours(0, 0, 0)),
            seq_id: 100,
            project_id: projectId || '',
            project_money: projectMoney || '',
        })
        resetExternal()
    }
    const cancelCallback = () => {
        handleChangeBoardModifyDialog(null)
        clearText()
        clearProjectId()
        clearProjectMoney()
        resetExternal()
    }
    const editCallback = async () => {
        const { data } = await request.get(`/apis/material/${board.material.id}`)
        handleSetEditMaterial({
            open: true,
            update: materialUpdate,
            isBom: isUser,
            modifyData: data,
            handleClose: () => {
                handleSetEditMaterial({
                    modifyData: null,
                    open: false,
                    update: false,
                    isBom: false,
                    handleClose: () => { },
                    handleConfirm: () => { },
                })
            },
            handleConfirm: async (newItem) => {
                try {
                    await request.put(`/apis/material/${newItem.id}/update`, newItem)
                    handleChangeModal({
                        show: true,
                        type: "success",
                        title: "修改成功！",
                        timeout: 800,
                        onConfirm: () => {
                            handleChangeModal(InitialModal)
                        },
                    })
                } catch (err) {
                    if (!navigator.onLine) {
                        handleChangeModal({
                            show: true,
                            type: "warning",
                            customButtons: [],
                            title: "oops! 断网啦！",
                            timeout: 3000,
                            onConfirm: () => {
                                handleChangeModal(InitialModal)
                            },
                        })
                        return
                    }
                    const { response: { data = {} } = {}, message } = err
                    handleChangeModal({
                        show: true,
                        type: "warning",
                        customButtons: [],
                        title: data.message || message,
                        timeout: 3000,
                        onConfirm: () => {
                            handleChangeModal(InitialModal)
                        },
                    })
                }
                handleSetEditMaterial({
                    modifyData: null,
                    open: false,
                    update: false,
                    isBom: false,
                    handleClose: () => { },
                    handleConfirm: () => { },
                })
            },
        })
    }
    return {
        callback, cancelCallback, editCallback,
        dialogData, disabled, isBusiness, isMine,
        text, handleChange,
        projectId, handleProjectIdChange,
        projectMoney, handleProjectMoneyChange,
        external, handleChangeAuthor, handleChangeArticleType,
        staticArticleType,
    }
}
